import { API_URL } from '@/api/auth/auth';
import { getStoredRefreshToken, TokensStore } from '@/features/stores/TokensStore';
import { getAuthMethods } from '@/hooks/useAuth';
import { ApiError } from '@/utils/apiError';

export async function fetchWithAuth(input: RequestInfo, init: RequestInit = {}) {
  const { logout, login } = getAuthMethods();
  const { accessToken } = TokensStore.state;
  const refreshToken = getStoredRefreshToken();

  const headers = new Headers(init.headers);

  const isFormData = typeof FormData !== 'undefined' && init.body instanceof FormData;
  if (!isFormData) {
    if (!headers.has('Content-Type') && init.body && typeof init.body === 'string') {
      headers.set('Content-Type', 'application/json');
    }
  }

  if (!headers.has('Accept')) headers.set('Accept', 'application/json');

  if (accessToken && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${accessToken}`);
  }

  const doFetch = () => fetch(input, { ...init, headers });

  const res = await doFetch();

  if (res.status !== 401) return res;

  const refreshRes = await fetch(API_URL + '/auth/refresh', {
    method: 'POST',
    body: JSON.stringify({ refresh_token: refreshToken }),
    headers: { 'Content-Type': 'application/json' },
  });

  if (!refreshRes.ok) {
    if (logout) {
      logout();
    }
    throw new ApiError('Unauthorized', 401);
  }

  const { access_token: newAccess, refresh_token: newRefresh } = await refreshRes.json();

  if (!newAccess || !newRefresh) {
    throw new Error('Missing tokens');
  }

  if (login) {
    login(newAccess, newRefresh);
  }

  headers.set('Authorization', `Bearer ${newAccess}`);

  return doFetch();
}
